export const getElementWidth = (element: Element) =>
  Math.floor(element.clientWidth);

export const curryScrollhandler = (el: Element, value: number | null) => ({
  handleScrollToLeft: () => value && el.scrollBy(-value, 0),
  handleScrollToRight: () => value && el.scrollBy(value, 0),
});
